"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientApi = exports.ClientApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
// @ts-ignore
const models_3 = require("../models");
// @ts-ignore
const models_4 = require("../models");
// @ts-ignore
const models_5 = require("../models");
// @ts-ignore
const models_6 = require("../models");
// @ts-ignore
const models_7 = require("../models");
// @ts-ignore
const models_8 = require("../models");
/**
 * ClientApi - axios parameter creator
 * @export
 */
const ClientApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ClientCreate} clientCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClient: async (clientCreate, options = {}) => {
            // verify required parameter 'clientCreate' is not null or undefined
            (0, common_1.assertParamExists)('addClient', 'clientCreate', clientCreate);
            const localVarPath = `/api/client/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clientCreate, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {IAddress} iAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addClientDeliveryAddress: async (clientId, iAddress, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('addClientDeliveryAddress', 'clientId', clientId);
            // verify required parameter 'iAddress' is not null or undefined
            (0, common_1.assertParamExists)('addClientDeliveryAddress', 'iAddress', iAddress);
            const localVarPath = `/api/client/delivery-address/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iAddress, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient: async (clientId, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('getClient', 'clientId', clientId);
            const localVarPath = `/api/client/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} clientNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientByClientNumber: async (clientNumber, options = {}) => {
            // verify required parameter 'clientNumber' is not null or undefined
            (0, common_1.assertParamExists)('getClientByClientNumber', 'clientNumber', clientNumber);
            const localVarPath = `/api/client/getClientByClientNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientNumber !== undefined) {
                localVarQueryParameter['client_number'] = clientNumber;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadAdAttribution: async (clientId, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('getLeadAdAttribution', 'clientId', clientId);
            const localVarPath = `/api/client/{client_id}/ad-attribution`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [includeInactive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadTypes: async (includeInactive, options = {}) => {
            const localVarPath = `/api/client/lead-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (includeInactive !== undefined) {
                localVarQueryParameter['include_inactive'] = includeInactive;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenMaintenances: async (clientId, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('getOpenMaintenances', 'clientId', clientId);
            const localVarPath = `/api/client/{client_id}/maintenance/open`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IClientFilterEntity} iClientFilterEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClients: async (iClientFilterEntity, options = {}) => {
            // verify required parameter 'iClientFilterEntity' is not null or undefined
            (0, common_1.assertParamExists)('listClients', 'iClientFilterEntity', iClientFilterEntity);
            const localVarPath = `/api/client/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iClientFilterEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeLeadAdAttributionNetworkData: async (options = {}) => {
            const localVarPath = `/api/client/ad-attribution/purge-network-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientMaintenanceActive: async (clientId, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('setClientMaintenanceActive', 'clientId', clientId);
            const localVarPath = `/api/client/setClientMaintenanceActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {boolean} [force]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientMaintenanceInActive: async (clientId, force, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('setClientMaintenanceInActive', 'clientId', clientId);
            const localVarPath = `/api/client/setClientMaintenanceInActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IClientEntity} iClientEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient: async (iClientEntity, options = {}) => {
            // verify required parameter 'iClientEntity' is not null or undefined
            (0, common_1.assertParamExists)('updateClient', 'iClientEntity', iClientEntity);
            const localVarPath = `/api/client/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iClientEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} clientId
         * @param {PartialIClientDataEntity} partialIClientDataEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientData: async (clientId, partialIClientDataEntity, options = {}) => {
            // verify required parameter 'clientId' is not null or undefined
            (0, common_1.assertParamExists)('updateClientData', 'clientId', clientId);
            // verify required parameter 'partialIClientDataEntity' is not null or undefined
            (0, common_1.assertParamExists)('updateClientData', 'partialIClientDataEntity', partialIClientDataEntity);
            const localVarPath = `/api/client/update/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(partialIClientDataEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ClientApiAxiosParamCreator = ClientApiAxiosParamCreator;
/**
 * ClientApi -
 */
var ClientApi;
(function (ClientApi) {
    /**
     *
     * @param {ClientCreate} clientCreate
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/add
     */
    async function addClient(clientCreate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addClient(clientCreate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseClientAttributes)(res.data);
            return res;
        });
    }
    ClientApi.addClient = addClient;
    /**
     *
     * @param {number} clientId
     * @param {IAddress} iAddress
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/delivery-address/add
     */
    async function addClientDeliveryAddress(clientId, iAddress, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addClientDeliveryAddress(clientId, iAddress, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    ClientApi.addClientDeliveryAddress = addClientDeliveryAddress;
    /**
     *
     * @param {number} clientId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/get
     */
    async function getClient(clientId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getClient(clientId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseIClientEntity)(res.data);
            return res;
        });
    }
    ClientApi.getClient = getClient;
    /**
     *
     * @param {string} clientNumber
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/getClientByClientNumber
     */
    async function getClientByClientNumber(clientNumber, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getClientByClientNumber(clientNumber, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_2.parseIClientEntity)(res.data);
            return res;
        });
    }
    ClientApi.getClientByClientNumber = getClientByClientNumber;
    /**
     *
     * @param {number} clientId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/{client_id}/ad-attribution
     */
    async function getLeadAdAttribution(clientId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadAdAttribution(clientId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseILeadAdAttributionView)(res.data);
            return res;
        });
    }
    ClientApi.getLeadAdAttribution = getLeadAdAttribution;
    /**
     *
     * @param {boolean} [includeInactive]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/lead-types
     */
    async function getLeadTypes(includeInactive, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadTypes(includeInactive, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_4.parseILeadTypeEntity)(x));
            return res;
        });
    }
    ClientApi.getLeadTypes = getLeadTypes;
    /**
     *
     * @param {number} clientId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/{client_id}/maintenance/open
     */
    async function getOpenMaintenances(clientId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getOpenMaintenances(clientId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_5.parseIPlanningItemEntity)(x));
            return res;
        });
    }
    ClientApi.getOpenMaintenances = getOpenMaintenances;
    /**
     *
     * @param {IClientFilterEntity} iClientFilterEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/list
     */
    async function listClients(iClientFilterEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listClients(iClientFilterEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_6.parseInlineResponse2001)(res.data);
            return res;
        });
    }
    ClientApi.listClients = listClients;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/ad-attribution/purge-network-data
     */
    async function purgeLeadAdAttributionNetworkData(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.purgeLeadAdAttributionNetworkData(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_8.parseInlineResponse2003)(res.data);
            return res;
        });
    }
    ClientApi.purgeLeadAdAttributionNetworkData = purgeLeadAdAttributionNetworkData;
    /**
     *
     * @param {number} clientId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/setClientMaintenanceActive
     */
    async function setClientMaintenanceActive(clientId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.setClientMaintenanceActive(clientId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    ClientApi.setClientMaintenanceActive = setClientMaintenanceActive;
    /**
     *
     * @param {number} clientId
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/setClientMaintenanceInActive
     */
    async function setClientMaintenanceInActive(clientId, force, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.setClientMaintenanceInActive(clientId, force, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_7.parseInlineResponse2002)(res.data);
            return res;
        });
    }
    ClientApi.setClientMaintenanceInActive = setClientMaintenanceInActive;
    /**
     *
     * @param {IClientEntity} iClientEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/update
     */
    async function updateClient(iClientEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateClient(iClientEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    ClientApi.updateClient = updateClient;
    /**
     *
     * @param {number} clientId
     * @param {PartialIClientDataEntity} partialIClientDataEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof ClientApi
     * url /api/client/update/data
     */
    async function updateClientData(clientId, partialIClientDataEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.ClientApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientData(clientId, partialIClientDataEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    ClientApi.updateClientData = updateClientData;
})(ClientApi || (exports.ClientApi = ClientApi = {}));
